import { render } from "./RadarChart.vue?vue&type=template&id=0db1ca3d&ts=true"
import script from "./RadarChart.vue?vue&type=script&lang=ts"
export * from "./RadarChart.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__